import { styled } from '@mui/material/styles';
import { FormControl, Box, Typography } from '@mui/material';

export const StyledFormControl = styled(FormControl)({
  width: '100%'
});

export const InfoBox = styled(Box)(({ theme }) => ({
  width: '100%',
  color: theme.palette.text.secondary,
  display: 'flex',
  justifyContent: 'center'
}));

export const InfoText = styled(Typography)(({ theme }) => ({
  width: theme.spacing(30),
  marginTop: theme.spacing(-3)
})); 